import { QuizAnswerDto, QuizQuestionDto } from './quiz-question.dto';

export class QuizQuestion {
    readonly id: string;
    readonly questionText: string;
    readonly answers: QuizAnswer[];

    constructor(dto: QuizQuestionDto) {
        this.id = dto.id;
        this.questionText = dto.questionText ?? '';
        this.answers = dto.answers.map((answerDto) => new QuizAnswer(answerDto));
    }
}

export class QuizAnswer {
    readonly value: string;
    readonly correct: boolean;

    constructor(dto: QuizAnswerDto) {
        this.value = dto.value ?? '';
        this.correct = dto.correct ?? false;
    }
}
